import type { ReactNode } from 'react';

interface ToggleChipProps {
  label: string;
  active: boolean;
  onToggle: () => void;
  swatch?: ReactNode;
}

/** Compact horizontal toggle, one per filterable value. One height, whatever the swatch. */
export function ToggleChip({ label, active, onToggle, swatch }: ToggleChipProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={active}
      className={`flex h-8 items-center gap-1.5 rounded-full bg-white px-2.5 text-[13px] leading-4 shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
        active ? 'text-primary-700 font-medium' : 'text-muted-foreground opacity-50'
      }`}
    >
      {swatch}
      <span>{label}</span>
    </button>
  );
}
